import { ArrowDownUp, ArrowDownNarrowWide, ArrowUpNarrowWide } from 'lucide-react';
import { useTasksStore, type SortMode } from '../../store/tasksStore';

const SORT_MODES: { mode: SortMode; label: string; Icon: typeof ArrowDownUp }[] = [
  { mode: 'manual', label: 'Manuel', Icon: ArrowDownUp },
  { mode: 'due-asc', label: 'Échéance ↑', Icon: ArrowUpNarrowWide },
  { mode: 'due-desc', label: 'Échéance ↓', Icon: ArrowDownNarrowWide },
];

export function TaskSortToggle() {
  const sortMode = useTasksStore((s) => s.sortMode);
  const setSortMode = useTasksStore((s) => s.setSortMode);

  return (
    <div className="inline-flex items-center rounded-lg border border-cime-border bg-white p-0.5 flex-shrink-0">
      {SORT_MODES.map(({ mode, label, Icon }) => {
        const isActive = mode === sortMode;
        return (
          <button
            key={mode}
            type="button"
            onClick={() => setSortMode(mode)}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium transition ${
              isActive
                ? 'bg-cime-primary text-white'
                : 'text-cime-text-muted hover:bg-[#fbfaf7]'
            }`}
            aria-pressed={isActive}
            title={`Trier : ${label}`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden md:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
